module.exports = function() {
  return new Worker(__webpack_public_path__ + "590913aaac0799627d33.worker.js");
};